<template>
    <div v-if="field">
        <div contenteditable="true" class="form-control" @input="onInput" v-bind="$attrs" ref="editor">{{ content }}</div>
    </div>
</template>
<script>

export default {
    name: "IdentityField_RefrenceText",
    components: {},
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number | Object,
            default: null
        },
        extendErrors: {
            type: Array
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                //this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        allErrors: {
            get() {
                return this.extendErrors
            },

            set(val) {
                this.errors = val
            }   
        }
    },
    watch: {
        content: function(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            val = val || ""

            this.errors = []
            this.allErrors = []

            if (val == "" && this.constraints.required) {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.field.type != 'email') {
                if (this.constraints.length !== undefined) {
                    if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                        if (val.length > this.constraints.length.max && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeMoreThenChars", {
                                    max: this.constraints.length.max
                                })
                            )
                        }
                    }
                    
                    if (this.constraints.length.min !== null) {
                        if (val.length < this.constraints.length.min && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeLessThenChars", {
                                    min: this.constraints.length.min
                                })
                            )
                        }
                    }
                }

                if (val.length > 0) {
                    if (this.constraints.not_allowed_words !== undefined) {
                        let notAllowedWords = this.constraints.not_allowed_words.split(",")
                        notAllowedWords.forEach(word => {
                            word = word.trim()

                            if (word != "") {
                                if (val.indexOf(word) !== -1) {
                                    if (word.length < 2) {
                                        this.errors.push(
                                            this.translator("identityField.symbolNotAllowed", {
                                                symbol: word
                                            })
                                        )
                                    } else {
                                        this.errors.push(
                                            this.translator("identityField.wordNotAllowed", {
                                                word: word
                                            })
                                        )
                                    }
                                }  
                            }              
                        })
                    }

                    if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                        let re = new RegExp(this.constraints.regex)
                        if (! re.test(val)) {
                            this.errors.push(this.translator("identityFields.invalidInput"))
                        }
                    }
                }
            }
        

            if (this.field.type == "email" && val.length > 0) {
                let re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
                if (! re.test(val)) {
                    this.errors.push(this.translator("identityField.invalidEmail"))
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length})
        },

        translateExtendedError(err) {
            return this.errorTrans[err] || err
        },

        onInput(e) {
            let editor = this.$refs.editor
            let newNode = new Text(String.fromCharCode(e.keyCode));
    
            editor.appendChild(newNode);

            console.log(editor.textContent)
        }
    },
    mounted() {
        if (this.constraints.default && this.content === null) {
            this.content = this.constraints.default
            return
        }

        this.check(this.content)
    }
}
</script>